import { Button } from '@bambi/component-library/src/components/Button/Button';

import type { PriceSummary } from '../external/bambi-api/bambiApi';
import { Modal } from '../primitives/Modal/Modal';
import { PriceSummaryTable } from 'src/features/pricing/PriceSummaryModal/PriceSummaryTable/PriceSummaryTable';

interface PricingSummaryModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  pricingSummary?: PriceSummary | null;
  noPriceSummaryFoundContent?: React.ReactNode;
}

export function PricingSummaryModal({
  open,
  onCancel,
  onConfirm,
  pricingSummary,
  noPriceSummaryFoundContent,
}: PricingSummaryModalProps) {
  return (
    <Modal
      open={open}
      setOpen={() => {}}
      contentClassnames="w-full max-w-[60vw]"
      data-testid="price-summary-modal"
      title="Price Summary"
    >
      {pricingSummary && pricingSummary.name ? (
        <div className="flex flex-col gap-y-2">
          <PriceSummaryTable summary={pricingSummary} />
          <div className="flex justify-end gap-4 pt-4">
            <Button
              variant="secondary"
              onClick={onCancel}
              dataTestId="price-summary-modal-cancel-button"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={onConfirm}
              dataTestId="price-summary-modal-accept-button"
            >
              Accept
            </Button>
          </div>
        </div>
      ) : (
        <>
          {noPriceSummaryFoundContent}
          <div className="flex justify-end gap-4 pt-4">
            <Button
              variant="secondary"
              onClick={onCancel}
              dataTestId="price-summary-modal-cancel-button"
            >
              Close
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
}
